import React, { useState, useEffect } from 'react';

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage first, then system preference
    const saved = localStorage.getItem('i7-dark-mode');
    if (saved !== null) {
      return JSON.parse(saved);
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // Apply theme on mount and changes
    localStorage.setItem('i7-dark-mode', JSON.stringify(isDarkMode));
    document.documentElement.classList.toggle('dark-theme', isDarkMode);
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle"
      aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
    >
      <div className="theme-toggle-track">
        <div className={`theme-toggle-thumb ${isDarkMode ? 'dark' : 'light'}`}>
          <span className="theme-toggle-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              {isDarkMode ? (
                // Black circle for dark mode
                <circle cx="7" cy="7" r="6" fill="currentColor" stroke="none"/>
              ) : (
                // White circle with black border for light mode  
                <circle cx="7" cy="7" r="6" fill="white" stroke="currentColor" strokeWidth="1"/>
              )}
            </svg>
          </span>
        </div>
      </div>
    </button>
  );
};

export default DarkModeToggle;